import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from '../css/Main.css';
import Navigation from '../components/Navigation.js';

import photo1 from '../../design/photos/rauchverband/R1.jpg';
import photo2 from '../../design/photos/rauchverband/R4.jpg';
import photo3 from '../../design/photos/rauchverband/R2.jpg';
import photo4 from '../../design/photos/rauchverband/R3.jpg';


import arrow from '../../design/photos/arrow.jpg';

export default class Rauchverband extends Component {
  constructor() {
    super();
    this.state = {
      count: 0,
      photocount: 0,
      photo: [photo1, photo2, photo3, photo4],
      what: [
        'Rauchbrand', 'Rauchbrand', 'Rauchbrand', 'Rauchbrand',
      ],
      size: [
        'H 11 cm', 'L 10 cm', 'H 12/28 cm', 'H 6 cm, D 10 cm',
      ],
      photographer: [
        'Foto: HS', 'Foto: HS', 'Foto: HS', 'Foto: HS',
      ],
    };
  }

  getImage() {
    return (
      <button onClick={() => this.bigPicture()} className={styles.button2}>
        <img
          alt={10}
          className={styles.photoSideshow}
          src={this.state.photo[this.state.photocount]}
        />
      </button>
    );
  }

  bigPicture() {
    this.setState({count: 2});
  }

  backToSlideshow() {
    this.setState({count: 1});
  }

  increment() {
    if (this.state.photocount === 3) {
      this.setState({ photocount: 0 });
    } else {
      this.setState({ photocount: this.state.photocount + 1 });
    }
  }

  decrement() {
    if (this.state.photocount === 0) {
      this.setState({ photocount: 3 });
    } else {
      this.setState({ photocount: this.state.photocount - 1 });
    }
  }

  handleClick(a) {
    if (this.state.count === 0) {
      this.setState({ count: 1 });
      this.setState({ photocount: a });
    } else {
      this.setState({ count: 0 });
    }
  }

  render() {
    if (this.state.count === 0) {
      return (
        <div className={styles.container}>
          <div className={styles.header}>
            <p className={styles.titleleft}>Hanna Schneider</p>
            <p className={styles.titleright}>Keramik</p>
          </div>
          <div className={styles.content}>
            <div className={styles.row1}>
              <button onClick={() => this.handleClick(0)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo1} />
              </button>
            </div>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(1)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo2} />
              </button>
            </div>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(2)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo3} />
              </button>
            </div>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(3)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo4} />
              </button>
            </div>
          </div>
          <Navigation />
        </div>
      );
    }
    if (this.state.count == 1) {
      return (
        <div className={styles.container}>
          <div className={styles.header}>
            <p className={styles.titleleft}>Hanna Schneider</p>
            <p className={styles.titleright}>Keramik</p>
          </div>
          <div className={styles.sideShowContainer}>
            <div className={styles.sideshowArea}>
              <button className={styles.buttonSideshow} onClick={() => this.decrement()}>
                <img alt={10} className={styles.imgSideshow} src={arrow} />
              </button>
              {this.getImage()}
              <button className={styles.buttonSideshow} onClick={() => this.increment()}>
                <img alt={10} className={styles.imgSideshow2} src={arrow} />
              </button>
            </div>
            <div className={styles.footer}>
              <div className={styles.descriptionArea}>
                <Link className={styles.link} to="arbeiten">
                  <button className={styles.back} onClick={() => this.handleClick(0)}>Zurück</button>
                </Link>
              </div>
              <div className={styles.descriptionArea}>
                <p className={styles.description}>{this.state.what[this.state.photocount]}</p>
                <p className={styles.description}>{this.state.size[this.state.photocount]}</p>
                <p className={styles.description}>{this.state.photographer[this.state.photocount]}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.bigImageArea}>
        <div className={styles.imageContainer}>
          <img
            className={styles.bigImage}
            alt={10}
            src={this.state.photo[this.state.photocount]}
          />
        </div>
        <button className={styles.bigBack} onClick={() => this.backToSlideshow()}> Zurück </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Rauchverband.js